<template>
    <div class="outcome">
        <span class="points-breakdown">{{ $t('predictors.details.pointsBreakdown') }}</span>
        <div class="details">
            <span v-for="(details, index) of details"
                :key="index"
                :class="['text', details.class]"
            >{{ details.text }}</span>
        </div>
        <span class="total-xp">{{ $t('predictors.details.total', {numberOfXP: `+${totalXpEarned}`}) }}</span>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'prediction-xp-points-american-football',
    props: {
        teamId: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapGetters('predictorPredictableSportEvents', [
            'getOutcomeUserParticipatedAmericanFootball',
            'getOutcomeCorrectWinningTeamAmericanFootball',
            'getOutcomeCorrectScoreRangeAmericanFootball',
        ]),

        outcomeUserParticipated() {
            return this.getOutcomeUserParticipatedAmericanFootball(this.teamId);
        },

        outcomeCorrectWinningTeam() {
            return this.getOutcomeCorrectWinningTeamAmericanFootball(this.teamId);
        },

        outcomeCorrectScoreRange() {
            return this.getOutcomeCorrectScoreRangeAmericanFootball(this.teamId);
        },

        totalXpEarned() {
            const allOutcomes = [
                this.outcomeUserParticipated,
                this.outcomeCorrectWinningTeam,
                this.outcomeCorrectScoreRange,
            ];

            return allOutcomes.reduce((totalPoints, outcome) => {
                if (!outcome.hasUserAchieved) {
                    return totalPoints;
                }

                return totalPoints + outcome.xp;
            }, 0);
        },

        details() {
            return [
                {
                    text: `${this.$t('predictors.details.outcomeUserParticipated')} `,
                    class: this.outcomeUserParticipated.classes,
                },
                {
                    text: `+${this.outcomeUserParticipated.xp} XP`,
                    class: `${this.outcomeUserParticipated.classes} text--bold`,
                },
                {
                    text: '\n',
                },
                {
                    text: `${this.$t('predictors.details.outcomeCorrectWinningTeam')} `,
                    class: this.outcomeCorrectWinningTeam.classes,
                },
                {
                    text: `+${this.outcomeCorrectWinningTeam.xp} XP`,
                    class: `${this.outcomeCorrectWinningTeam.classes} text--bold`,
                },
                {
                    text: '\n',
                },
                {
                    text: `${this.$t('predictors.details.outcomeCorrectScoreRange')} `,
                    class: this.outcomeCorrectScoreRange.classes,
                },
                {
                    text: `+${this.outcomeCorrectScoreRange.xp} XP`,
                    class: `${this.outcomeCorrectScoreRange.classes} text--bold`,
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.outcome {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

.points-breakdown {
    font-family: Nunito;
    color: $daintree-color;
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;

    @include min-width(md) {
        font-size: 1.6rem;
    }
}

.total-xp {
    font-family: Nunito;
    font-weight: bold;
    font-size: 1.3rem;
    color: $daintree-color;

    @include min-width(md) {
        font-size: 1.6rem;
    }
}

.details {
    margin-bottom: 0.9rem;
    white-space: pre;
    text-align: center;
}

.text {
    font-family: Nunito;
    font-size: 1.2rem;

    @include min-width(md) {
        font-size: 1.5rem;
    }

    &--bold {
        font-weight: bold;
    }

    &--opacity-30 {
        color: rgba($cyprus-color, 0.3);
    }
}
</style>